import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {WebsiteDetailedBannerComponent} from './website-detailed-banner.component'
import {BrowserModule} from '@angular/platform-browser'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import {SharedModule} from '../shared/shared.module'

@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    SharedModule
  ],
  declarations: [WebsiteDetailedBannerComponent],
  exports: [
    WebsiteDetailedBannerComponent
  ],
  providers: []
})
export class WebsiteDetailedBannerModule {
}
